// extracted by mini-css-extract-plugin
export default {"form":"Form_form__0-Rrd","header":"Form_header__5cObw","footer":"Form_footer__EWWOX","imgLogin":"Form_imgLogin__XBAUS"};